<template>
  <div>
    <template v-if="!getTextModel">
      <el-cascader
        style="width: 100%"
        :options="item.dataList ? enums[item.dataList] : enums[item.data]"
        v-model="form[item.bind]"
        filterable
        @change="
          (val) => {
            item.change && item.change(val, item);
          }
        "
        v-bind="item"
      ></el-cascader>
    </template>
    <div v-else>
      {{ getTextContent }}
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemCascader",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formComConfig: {
      type: Object,
      default: () => ({}),
    },
    enums: {
      type: Object,
    },
  },
  computed: {
    // 是否采用文字模式
    getTextModel() {
      if (undefined === this.item.isText || '' === this.item.isText) {
        // item没有设置是否纯文本显示，判断全局的textModel
        return this.formComConfig.textModel;
      } else {
        return this.item.isText;
      }
    },
    getTextContent() {
      let val = this.form[this.item.bind];
       let dataList = this.item.dataList
        ? this.enums[this.item.dataList]
        : this.enums[this.item.data];
      let target = [];
      let content = "";
      let result = null;
      if (val) {
        if (Object.prototype.toString.call(val) === "[object Array]") {
          val.map((valItem, valIndex) => {
            // 多选的是二维数组
            if (Object.prototype.toString.call(valItem) === "[object Array]") {
              if (valIndex == 0) {
                content += this.getSingleArr(valItem);
              } else {
                content += ", " + this.getSingleArr(valItem);
              }
            } else {
              // 单选的是一维数组
              if (valIndex == 0) {
                result = this.getNameByVal(valItem, dataList);
                content += result.content;
              } else {
                result = this.getNameByVal(valItem, target);
                content += "/" + result.content;
              }
              target = result.nextTarget;
            }
          });
        }
      }
      return content;
    },
  },
  methods: {
    getSingleArr(val) {
      let dataList = this.item.dataList
        ? this.enums[this.item.dataList]
        : this.enums[this.item.data];
      let content = "";
      let target = [];
      let result = null;
      val.map((valItem, valIndex) => {
        if (valIndex == 0) {
          result = this.getNameByVal(valItem, dataList);
          content += result.content;
        } else {
          result = this.getNameByVal(valItem, target);
          content += "/" + result.content;
        }
        target = result.nextTarget;
      });
      return content;
    },
    getNameByVal(val, dataList) {
      let content = "";
      let nextTarget = [];
      if (dataList && dataList.length) {
        for (let i = 0, len = dataList.length; i < len; i++) {
          let eItem = dataList[i];
          if (eItem["value"] == val) {
            content = eItem["label"];
            if (eItem.children && eItem.children.length > 0) {
              nextTarget = eItem.children;
            }
            break;
          }
        }
      }
      return { content, nextTarget };
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// packages/SrAdd/components/form-item-cascader.vue